// Custom typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

// Prism syntax highlighting theme
import 'prismjs/themes/prism-okaidia.css'

// Global styles for mobile responsiveness
import './src/styles/global.css'

// Markdown HTML can't run scripts, so load the X widget when a page embeds a tweet
export const onRouteUpdate = () => {
  if (!document.querySelector('.twitter-tweet')) return

  if (window.twttr && window.twttr.widgets) {
    window.twttr.widgets.load()
    return
  }

  if (document.getElementById('twitter-wjs')) return

  const script = document.createElement('script')
  script.id = 'twitter-wjs'
  script.src = 'https://platform.twitter.com/widgets.js'
  script.async = true
  document.body.appendChild(script)
}
